import { jsx as t, jsxs as T } from "react/jsx-runtime";
import { useTheme as S, Box as f, Typography as _, alpha as m, Avatar as b, Divider as w, Grow as L } from "@mui/material";
import { _ as k, V as v, l as I, s as j } from "../../../index-DVHhaa_b.js";
import { NotificationType as z } from "../../../helpers/daymaptypes.js";
import { useNotifications as A } from "../../../context/notifications/index.js";
import x from "react";
const B = ({ NotificationID: d, StudentID: o, Title: s, Message: r, NotificationType: i, SentAt: l, Read: e, onClick: a, inModal: p, Properties: h }) => {
  let { color: n, icon: y, iconType: u } = k(i, { fontSize: "small" });
  const { setRead: D } = A(), N = S();
  let c, g = /* @__PURE__ */ t("div", { dangerouslySetInnerHTML: { __html: r } });
  return o ? c = /* @__PURE__ */ t(v, { studentId: o, color: n, icon: /* @__PURE__ */ t(I, { iconType: u, sx: { width: 17, height: 17 } }) }) : i === z.PeerToPeerMessage && h.SenderID ? (g = /* @__PURE__ */ t(f, { sx: { backgroundColor: m(N.palette.background.paper, 0.5) }, py: 0.5, px: 1, m: 0.5, children: /* @__PURE__ */ t(_, { component: "div", fontWeight: 400, fontSize: ".8rem", children: /* @__PURE__ */ t("div", { dangerouslySetInnerHTML: { __html: r } }) }) }), c = /* @__PURE__ */ t(v, { contactId: Number(h.SenderID), color: n, icon: /* @__PURE__ */ t(I, { iconType: u, sx: { width: 14, height: 14 } }) })) : c = /* @__PURE__ */ t(b, { variant: "rounded", sx: {
    height: 30,
    width: 30,
    bgcolor: e ? "transparent" : m(n, 0.15),
    color: e ? m(n, 0.45) : n
  }, children: y }), /* @__PURE__ */ t(
    j,
    {
      itemType: "notification",
      title: s,
      description: g,
      date: l,
      avatar: c,
      onClick: a,
      variant: e ? "subdued" : void 0,
      elevation: p ? 0 : 1,
      bgcolor: p ? "transparent" : void 0,
      unread: !e,
      onUnreadClicked: () => D(d)
    }
  );
}, O = ({ notifications: d, inModal: o, showStudent: s = !0, growIn: r }) => /* @__PURE__ */ t(f, { display: "flex", gap: 1, flexDirection: "column", children: d.map((i, l, e) => {
  const a = /* @__PURE__ */ T(x.Fragment, { children: [
    /* @__PURE__ */ t(B, { ...i, StudentID: s ? i.StudentID : void 0, inModal: o }, i.NotificationID),
    o && l + 1 < e.length && /* @__PURE__ */ t(w, { variant: "middle" })
  ] }, i.NotificationID);
  return r ? /* @__PURE__ */ t(x.Fragment, { children: /* @__PURE__ */ t(L, { in: !0, style: { transitionDuration: ".5s, 156ms" }, children: /* @__PURE__ */ t(f, { children: a }) }) }, i.NotificationID) : a;
}) });
export {
  B as NotificationItem,
  O as NotificationList
};
//# sourceMappingURL=notification.js.map
